import AbstractUpload from './AbstractUpload'

import i18n from '@/i18n'

function formatBytes (bytes, decimals = 0) {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export default class ImageUpload extends AbstractUpload {
  /**
  * Create new image upload
  *
  * @param {number} maximumSize
  */
  constructor (maximumSize, accept = 'image.*', acceptErrorMessage = i18n.t('sentence.acceptImageErrorMessage')) {
    super(maximumSize, i18n.t('sentence.maximumSizeErrorMessage{size}', { size: formatBytes(maximumSize) }), accept, acceptErrorMessage)
  }
}
